import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact | Juwai Morning Teer"
        description="Get in touch with the Juwai Morning Teer editorial team for corrections, feedback or content queries."
        path="/contact"
      />
      <PageShell>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
          Contact
        </h1>
        <div className="prose prose-sm sm:prose-base max-w-none mt-4 text-slate-700 leading-relaxed">
          <p>
            For corrections, feedback, or content queries, please reach out to
            us via email:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:contact@juwaimorningteer.example" className="text-emerald-800 underline">
              contact@juwaimorningteer.example
            </a>
          </p>
          <p>
            We aim to respond to legitimate enquiries within 2–3 working days.
            Please note we cannot accept requests to change or predict future
            results, or requests related to betting or gambling activity of any
            kind.
          </p>
        </div>
      </PageShell>
    </>
  );
}
